import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/lib/content";
import { Reveal } from "@/components/motion/Reveal";

export function Process({ dark = false }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const line = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  const t = dark ? "text-paper" : "text-ink";
  const m = dark ? "text-paper/55" : "text-mute";
  const l = dark ? "bg-paper/15" : "bg-line";

  return (
    <section ref={ref} className={`${dark ? "bg-ink" : "bg-paper"} py-28 md:py-40 border-t ${dark ? "border-paper/10" : "border-line"}`} aria-labelledby="process-title">
      <div className="container-x">
        <Reveal className="mb-20 md:mb-28 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className={`label ${m} mb-6 flex items-center gap-4`}><span className={`w-6 h-px ${dark ? "bg-paper/40" : "bg-ink/40"}`} /> 05 · Ablauf</p>
            <h2 id="process-title" className={`display text-4xl sm:text-5xl lg:text-6xl ${t}`}>So arbeiten wir.</h2>
          </div>
          <p className={`max-w-sm text-sm md:text-base ${m} leading-relaxed`}>Klare Abläufe. Saubere Ergebnisse. Von der ersten Anfrage bis zur Übergabe.</p>
        </Reveal>

        <div className="relative">
          <div className={`absolute left-0 lg:left-0 top-0 lg:top-2 w-px lg:w-full h-full lg:h-px ${l}`} />
          <motion.div style={{ width: line }} className={`hidden lg:block absolute left-0 top-2 h-px ${dark ? "bg-paper" : "bg-ink"}`} />
          <motion.div style={{ height: line }} className={`lg:hidden absolute left-0 top-0 w-px ${dark ? "bg-paper" : "bg-ink"}`} />

          <ol className="grid lg:grid-cols-6 gap-y-12 lg:gap-x-6 pl-8 lg:pl-0">
            {PROCESS.map((p, i) => (
              <Reveal as="li" key={p.n} delay={i * 0.08} className="relative lg:pt-10">
                <span className={`absolute -left-8 top-1 lg:left-0 lg:top-0 w-[7px] h-[7px] -translate-x-[3px] lg:-translate-y-[3px] rounded-full ${i === 0 ? "bg-signal" : dark ? "bg-paper" : "bg-ink"}`} />
                <span className={`label ${m}`}>{p.n}</span>
                <h3 className={`display text-2xl lg:text-xl xl:text-2xl mt-3 uppercase tracking-[-0.01em] ${t}`}>{p.t}</h3>
                <p className={`text-sm ${m} mt-3 leading-relaxed max-w-[26ch]`}>{p.d}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
